export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-chord/src/array.js
// module id = 312
// module chunks = 0